export default "/images/vendor/flag-icon-css/flags/4x3/fo.svg?f284df39e89f9ed508ad86e7b0c7d2ac";